// Copy of styles to use when download svg
export const styles = {
  template1: `
    @font-face {
      font-family: 'Bebas Kai';
      src: url('../fonts/BebasKai.otf');
    }
    @font-face {
      font-family: 'Lolapeluza';
      src: url('../fonts/Lolapeluza.ttf');
    }

    .t1-background-dark {
      fill: url(#linear-gradient);
    }

    .t1-background-light {
      fill: url(#linear-gradient-neutral);
    }

    .t1-border-dark {
      fill: #2f2f2f;
    }
    .t1-border-light {
      fill: url(#linear-gradient);
    }

    .t1-lines-container {
      opacity: 0.2;
    }

    .t1-lines-dark {
      fill: none;
      stroke: #2f2f2f;
      stroke-width: 1px;
    }

    .t1-lines-light {
      fill: none;
      stroke: #ffffff34;
      stroke-width: 1px;
    }

    .t1-username, .t1-festival{
      font-family: ø, Lolapeluza;
    }

    .t1-username {
      font-size: 118.249px;
    }

    .t1-festival {
      font-size: 123.943px;
    }

    .t1-square-sexta {
      fill: #653371;
    }

    .t1-repository-names {
      font-size: 63.488px;
      text-anchor: middle;
      font-family: "Bebas Kai";
    }

    .t1-square-sabado {
      fill: #b074ad;
    }

    .t1-square-domingo{
      fill: #dd9f87;
    }

    .t1-square-sabado, .t1-square-domingo, .t1-github, .t1-border-dark, .t1-border-light, .t1-lines-dark, .t1-lines-light, .t1-square-sexta, .t1-support-text {
      fill-rule: evenodd;
    }

    .t1-support-text, .t1-github, .t1-repository-names, .t1-username, .t1-festival, .t1-festival-line {
      fill: #fdf9ff;
    }
  `
}
